import userService from "../../services/user.service";
import { ActionTypes } from "../Constants/ActionTypes";

export const resetPasswordThroughEmail = (dispatch, payload) => {
  userService
    .forgotPassword(payload.email)
    .then((res) => {
      if ((res.status == 200) & (res.data.success == true)) {
        dispatch({
          type: ActionTypes.OPEN_SUCCESS_POPUP,
          payload: {
            successPopUp: {
              message: "Reset Password Link Sent To The Registered Email.",
              open: true,
            },
          },
        });
        dispatch({
          type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
          payload: false,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
        payload: false,
      });
      dispatch({
        type: ActionTypes.OPEN_FAIL_DIALOG,
        payload: {
          open: true,
          message: "Something Went Wrong",
        },
      });
    });
};
